import gql from 'graphql-tag';

export const CREATE_TV_APP_CONFIGURATION_MUTATION = gql`
  mutation CreateTvAppConfiguration($data: createTvAppConfigurationInput!) {
    createTvAppConfiguration(input: $data) {
      tvAppConfiguration {
        id
        name
        slug
      }
    }
  }
`;
